import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, JobFileWithSignedUrlResponse } from "@/types";

export function useGetJobFile({
  enabled,
  jobFileId,
}: {
  enabled: boolean;
  jobFileId: number;
}) {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["files", currentCompanyId, currentJobId, jobFileId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/files/${jobFileId.toString()}`;
      const res = await guacHttpClient.get<
        JobFileWithSignedUrlResponse,
        HttpResponse<JobFileWithSignedUrlResponse>
      >(path);
      return res.data;
    },
    enabled: !!enabled,
  });
}
